// extracted by mini-css-extract-plugin
export default {"navbarWrapper":"Navbar_navbarWrapper__tusAO","navbar":"Navbar_navbar__n7ygh","logo":"Navbar_logo__jA5Pb","menu":"Navbar_menu__Imi9Z","account":"Navbar_account__z4nV7"};